/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export const timeout = (millies, f) => {
    if (millies === "INFINITELY") {
        return f(() => false);
    }
    let done = false;
    const doneF = () => done;
    return new Promise((resolve, reject) => {
        const timeoutRef = setTimeout(() => {
            done = true;
            reject(new Error("Timeout after " + millies + "ms"));
        }, millies);
        const result = f(doneF);
        // result.finally(() => clearTimeout(timeoutRef));
        result.then(r => {
            resolve(r);
            clearTimeout(timeoutRef);
        }, e => {
            reject(e);
            clearTimeout(timeoutRef);
        });
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGltZW91dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlsaXRpZXMvcHJvbWlzZXMvdGltZW91dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sQ0FBQyxNQUFNLE9BQU8sR0FBNkYsQ0FBQyxPQUFPLEVBQUUsQ0FBQyxFQUFFLEVBQUU7SUFFNUgsSUFBSSxPQUFPLEtBQUssWUFBWSxFQUFFO1FBQzFCLE9BQU8sQ0FBQyxDQUFDLEdBQUcsRUFBRSxDQUFDLEtBQUssQ0FBQyxDQUFBO0tBQ3hCO0lBRUQsSUFBSSxJQUFJLEdBQUcsS0FBSyxDQUFDO0lBQ2pCLE1BQU0sS0FBSyxHQUFHLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQztJQUV6QixPQUFPLElBQUksT0FBTyxDQUFDLENBQUMsT0FBTyxFQUFFLE1BQU0sRUFBRSxFQUFFO1FBRW5DLE1BQU0sVUFBVSxHQUFHLFVBQVUsQ0FBQyxHQUFHLEVBQUU7WUFDL0IsSUFBSSxHQUFHLElBQUksQ0FBQztZQUNaLE1BQU0sQ0FBQyxJQUFJLEtBQUssQ0FBQyxnQkFBZ0IsR0FBRyxPQUFPLEdBQUcsSUFBSSxDQUFDLENBQUMsQ0FBQztRQUN6RCxDQUFDLEVBQUUsT0FBTyxDQUFDLENBQUM7UUFFWixNQUFNLE1BQU0sR0FBRyxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUM7UUFDeEIsa0RBQWtEO1FBRWxELE1BQU0sQ0FBQyxJQUFJLENBQ1AsQ0FBQyxDQUFDLEVBQUU7WUFDQSxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDWCxZQUFZLENBQUMsVUFBVSxDQUFDLENBQUM7UUFDN0IsQ0FBQyxFQUNELENBQUMsQ0FBQyxFQUFFO1lBQ0EsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ1YsWUFBWSxDQUFDLFVBQVUsQ0FBQyxDQUFDO1FBQzdCLENBQUMsQ0FDSixDQUFDO0lBQ04sQ0FBQyxDQUFDLENBQUM7QUFDUCxDQUFDLENBQUMifQ==